module.exports = __webpack_public_path__ + "de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/flags/de.png
// module id = 1062
// module chunks = 0